import type { GameMeta } from '@gmp/game-sdk';

export { PN_CATEGORIES, PN_CATEGORY_IDS, PN_ROUNDS, PHOTO_CATEGORIES, PHOTO_CATEGORY_IDS, type PnCategory, type PnRoundId, type PhotoCategory } from './categories';

/** Catalog data only (no rules or content), so menus can show the game without loading it. */
export const phonenanigansMeta = {
  id: 'phonenanigans',
  name: 'Phonenanigans',
  tagline: 'Your phones are the answers.',
  description:
    'Who has the lowest battery? How many of you are on silent? Everyone checks their own phone and answers privately, then the room guesses. Round 2: everyone shares a text they really sent (or asks for a harmless fake) and you guess who sent it. Round 3: a camera-roll scavenger hunt where the fastest real match wins. Honour system: nothing on your phone is read unless you tap.',
  minPlayers: 3,
  maxPlayers: 12,
  estimatedMinutes: [15, 30],
  usesMedia: true,
  modes: [{ id: 'classic', name: 'Three rounds', description: 'Device Check, Sent Texts and Camera Roll Hunt (the host can switch rounds 2 and 3 off).' }],
  theme: { primary: '#7cf06b', secondary: '#ff5fd2', background: '#0b1020', ink: '#f2fbff' },
  readiness: 'beta',
  genre: 'Phone-snooping party quiz',
  controls: 'tap',
  category: 'party',
  instructions: [
    { icon: 'Smartphone', title: 'Check your phone', body: 'Each question starts with you: look up your battery, storage, photo count or a setting and answer for the phone in your hand. Only you see your answer.' },
    { icon: 'Users', title: 'Then guess the room', body: 'Who has the lowest? How many of us? How many does Sam have? Right guesses score, and the reveal charts everyone’s answers.' },
    { icon: 'MessageCircle', title: 'Sent Texts', body: 'Share a recent text you sent that you are happy for the room to see, or tap “Give me a fake one”. Guess who sent each text; fool people for points.' },
    { icon: 'Images', title: 'Camera Roll Hunt', body: 'A prompt appears: find a matching photo in your library and send it. The room votes thumbs up or down on each photo and picks the best match.' },
    { icon: 'ShieldCheck', title: 'Honour system', body: 'The game never reads your phone on its own. A few answers can be filled in when you tap (battery, dark mode, iPhone or Android): check them and correct them.' },
  ],
} satisfies GameMeta;
